<template>
  <div class="crewHome">
    <div class="crewHome-content">
      <el-form :inline="true" :model="formInline" class="other-form-inline">
        <el-form-item class="flex-form">
          <el-date-picker
            class="hide-icon"
            type="date"
            placeholder="开始时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="formInline.laborApproveDateBegin"
            style="width: 100px"
          ></el-date-picker>
          <span class="line" style="margin: 0 3px">-</span>
          <el-date-picker
            class="hide-icon"
            placeholder="结束时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="formInline.laborApproveDateEnd"
            style="width: 100px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="formInline.shipName"
            placeholder="搜索船舶"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="formInline.approveState"
            placeholder="是否核准"
            style="width: 135px"
          >
            <el-option label="是否核准" value=""></el-option>
            <el-option label="待审核" value="1"></el-option>
            <el-option label="已审核" value="2"></el-option>
            <!-- <el-option label="审核不通过" value="3"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="other-search" @click="onSubmit">
            <i class="el-icon-search"></i>
          </div>
        </el-form-item>
      </el-form>
      <div style="clear: both"></div>
      <el-divider class="other-divider"></el-divider>
      <div class="other-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column prop="month" label="奖励月份" min-width="100">
          </el-table-column>
          <el-table-column prop="shipName" label="船舶名称" min-width="80">
          </el-table-column>
          <el-table-column prop="reward" label="发送金额" min-width="140">
          </el-table-column>
          <el-table-column
            prop="laborApproveTime"
            label="核准日期"
            min-width="120"
          >
          </el-table-column>
          <el-table-column prop="approveState" label="是否审核" min-width="100">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.approveState == 1">待审核</span>
              <span v-if="scope.row.approveState == 2">已审核</span> -->
              <span>{{ scope.row.approveStateName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="160">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="other-watch"
                @click="comDetail(scope)"
              >
                查看
              </el-button>
              <!-- <el-button type="text" size="small" class="other-watch">
                下载
              </el-button> -->
              <el-button
                v-if="scope.row.approveState == 1"
                type="text"
                size="small"
                class="other-green"
                @click="passInvite(scope)"
              >
                审核
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div class="other-block">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage1"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      class="other-dialog"
      width="450px"
      title="审核通过"
      :visible.sync="companyVisible"
      ref="vueRef"
      :before-close="handleClose"
    >
      <el-form
        label-width="120px"
        :model="jobParams"
        class="other-form"
        :rules="rules"
      >
        <el-form-item label="是否属于本公司" prop="userState">
          <el-select v-model="jobParams.userState" placeholder="是否属于本公司">
            <el-option label="是" value="1"> </el-option>
            <el-option label="否" value="2"> </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="船员类型" prop="crewType">
          <el-select
            v-model="jobParams.crewType"
            placeholder="招聘职位"
            style="width: 135px"
          >
            <el-option label="自有船员" value="1"> </el-option>
            <el-option label="借调船员" value="2"> </el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="other-footer">
        <el-button @click="companyVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="rememendCrewPass()"
          :loading="remendLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getSpecialSafetyGroupShipList, crewAudit } from "@/apis/index";
export default {
  data() {
    return {
      formInline: {},
      tableData: [],
      currentPage1: 1,
      pageNo: "1",
      total: 0,
      pageSize: 10,
      companyVisible: false,
      jobParams: {},
      remendLoading: false,
      diaList: {},
      rules: {
        userState: [
          {
            required: true,
            message: "请选择员工在本派遣机构状态",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getCrewInfoList();
  },
  methods: {
    onSubmit() {
      this.pageNo = 1;
      this.getCrewInfoList();
    },
    handleOpen() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCrewInfoList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getCrewInfoList();
      // console.log(`当前页: ${val}`);
    },
    choseCom() {
      this.companyVisible = true;
    },
    handleClose() {
      this.companyVisible = false;
    },
    comDetail(item) {
      this.$router.push({
        name: "rewardsDetail",
        params: {
          id: item.row.id,
          type: "1",
        },
      });
    },
    passInvite(item) {
      this.$router.push({
        name: "rewardsDetail",
        params: {
          id: item.row.id,
          type: "2",
        },
      });
    },
    async getCrewInfoList() {
      let res = await getSpecialSafetyGroupShipList({
        ...this.formInline,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      this.total = res.data.rowCount;
      this.tableData = res.data.resultList;
      this.tableData.forEach((item) => {
        if (item.inviteTime) {
          item.inviteTime = item.inviteTime.split(" ")[0];
        }
      });
    },

    delInvite(scope) {
      this.$confirm("确定要淘汰吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.delList(scope.row);
          // console.log(scope);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async delList(row) {
      await crewAudit({
        agentAuditState: "3",
        userId: row.userId,
        agentCyAuditId: row.agentCyAuditId,
        userOrigin: "2",
      });
      // console.log(res);
      this.getCrewInfoList();
    },
    rememendCrewPass() {
      if (!this.jobParams.userState) {
        this.$message({
          message: "请选择是否属于本公司",
          type: "error",
        });
        return;
      }
      this.remendLoading = true;
      this.addCrewList();
    },
    async addCrewList() {
      let res = await crewAudit({
        userState: this.jobParams.userState,
        crewType: this.jobParams.crewType,
        agentAuditState: "2",
        userId: this.diaList.userId,
        agentCyAuditId: this.diaList.agentCyAuditId,
        userOrigin: "2",
      });
      if (res.code == 1) {
        this.$message({
          message: "成功",
          type: "success",
        });
        this.remendLoading = false;
        this.companyVisible = false;
        this.getCrewInfoList();
        // this.$router.push({ name: "邀请船员" });
      } else {
        this.$message({
          message: res.msg,
          type: "warning",
        });
        this.remendLoading = false;
        this.companyVisible = false;
      }
      // console.log(res);
    },
  },
};
</script>
